import { useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { GET_SUBMISSION } from './submission.query';
import { GET_QUOTES } from './quotes.query';

const CREATE_QUOTE_PACKAGE_MUTATION = graphql(`
  mutation createQuotePackage($quoteUuids: [String!]!) {
    createQuotePackage(quoteUuids: $quoteUuids) {
      result
      savedDocuments
      folder
    }
  }
`);

export function useCreateQuotePackageMutation() {
  const [createQuotePackage, { data, loading, error, reset }] = useMutation(
    CREATE_QUOTE_PACKAGE_MUTATION,
    {
      refetchQueries: [GET_SUBMISSION, GET_QUOTES],
      awaitRefetchQueries: true,
    }
  );

  return {
    data,
    createQuotePackage,
    loading,
    error,
    reset,
  };
}

const PACKAGE_QUOTE_MUTATION = graphql(`
  mutation packageQuotes($submissionUuid: String!, $quoteUuids: [String!]!) {
    packageQuotes(submissionUuid: $submissionUuid, quoteUuids: $quoteUuids) {
      result
      savedDocuments
      folder
    }
  }
`);

export function usePackageQuoteMutation() {
  const [packageQuote, { data, loading, error, reset }] = useMutation(
    PACKAGE_QUOTE_MUTATION,
    {
      refetchQueries: [GET_SUBMISSION, GET_QUOTES],
      awaitRefetchQueries: true,
    }
  );

  return {
    data,
    packageQuote,
    loading,
    error,
    reset,
  };
}
